/**
 * Validate handle format - allow alphanumeric characters and underscores in any language
 * @param value - The handle value to validate
 * @returns boolean - true if valid, false if invalid
 */
export const isValidHandleFormat = (value: string): boolean => {
  // First check if the value is empty or only whitespace
  if (!value || !value.trim()) {
    return false;
  }

  // Ensure that the length is between 4 and 15 characters
  if (value.length < 4 || value.length > 15) {
    return false;
  }

  try {
    // Primary Unicode regex: \p{L} = letters, \p{N} = numbers, \p{M} = marks/combining characters, _ = underscore
    const validPattern = /^[\p{L}\p{N}\p{M}_]+$/u;
    return validPattern.test(value);
  } catch (error) {
    // Fallback for older browsers that don't support Unicode property escapes
    console.warn('Unicode property escapes not supported, using fallback regex');
    
    // Fallback pattern that covers most common Unicode ranges
    // Latin, Arabic, Chinese, Japanese, Korean, Cyrillic, Hebrew, Devanagari, etc.
    const fallbackPattern = /^[a-zA-Z0-9_\u00C0-\u017F\u0400-\u04FF\u0590-\u05FF\u0600-\u06FF\u0900-\u097F\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF\uAC00-\uD7AF\u1100-\u11FF]+$/;
    return fallbackPattern.test(value);
  }
};
